export const dispatcher = {
    positionDroppedLoader: (showLoader = false) => {
        window.dispatchEvent(
            new CustomEvent('legacy:dnd:positionDroppedLoader:ready', {
                detail: {
                    showLoader,
                },
            })
        );
    },
    excessChanged: ({
        payload,
        hasCommentsFromClient,
        documentDate,
    }: {
        payload: unknown;
        hasCommentsFromClient: boolean;
        documentDate: string;
    }) => {
        window.dispatchEvent(
            new CustomEvent('legacy:dnd:excess:changed', {
                detail: {
                    mode: 'create',
                    updatedData: payload,
                    hasCommentsFromClient,
                    dateNow: Date.now(),
                    documentDate,
                },
            })
        );
    },
    positionDroppedCreate: ({
        positionGuid,
        createdCheckGuid,
        updatedData,
        documentDate,
    }: {
        positionGuid: string;
        createdCheckGuid: string;
        updatedData: unknown;
        documentDate: string;
    }) => {
        window.dispatchEvent(
            new CustomEvent('legacy:dnd:positionDropped:ready', {
                detail: {
                    needToRefetch: true,
                    mode: 'create',
                    positionGuid,
                    createdCheckGuid,
                    updatedData,
                    dateNow: Date.now(),
                    documentDate,
                },
            })
        );
    },
    positionDroppedUpdate: ({
        updatedCheckGuid,
        positionGuid,
        updatedData,
        supplierFromClient,
        documentDate,
    }: {
        updatedCheckGuid: string;
        positionGuid: string;
        updatedData: unknown;
        supplierFromClient: string;
        documentDate: string;
    }) => {
        window.dispatchEvent(
            new CustomEvent('legacy:dnd:positionDropped:ready', {
                detail: {
                    needToRefetch: true,
                    mode: 'update',
                    updatedCheckGuid,
                    positionGuid,
                    updatedData,
                    supplierFromClient,
                    dateNow: Date.now(),
                    documentDate,
                },
            })
        );
    },
};
